import React from 'react';
import BondDocuments from '../../components/shared/BondDocuments';

export default function FacilityAgentBondDocuments() {
    return <BondDocuments role="facility-agent" />;
}
